var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 5,
    viewBox: "0 0 209 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.532 2.5707C208.524 2.81534 205.601 3.01027 200.321 3.129C195.041 3.24773 187.403 3.3125 177.963 3.31903C168.5 3.36932 157.333 3.07513 144.895 3.56356C138.677 3.76329 132.144 4.06415 125.305 4.19928C118.488 4.33512 111.434 4.24066 104.246 4.16412C89.8933 3.94505 76.1865 4.41473 63.6964 4.43397C51.2041 4.51992 39.9437 4.37854 30.4948 3.98404C21.0472 3.54506 13.4477 3.09903 8.16191 2.70552C2.89831 2.31274 -0.0078921 1.99617 1.60971e-05 1.75153C0.0079243 1.5069 2.92922 1.35644 8.20648 1.32667C13.4845 1.27466 21.1406 1.34405 30.5538 1.47024C39.9683 1.55195 51.1929 1.42502 63.6464 1.15971C76.0977 0.961121 89.8297 0.403198 104.272 0.602906C111.483 0.680161 118.492 0.773185 125.24 0.701905C132.013 0.564625 138.563 0.420156 144.778 0.287143C157.278 -0.0434464 168.592 0.522644 178 0.804511C187.43 1.10934 195.055 1.44489 200.322 1.72647C205.588 2.03029 208.496 2.30239 208.488 2.54703L208.532 2.5707Z",
    fill: "#3C73FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineFilled);
export default __webpack_public_path__ + "static/media/LineFilled.13e31db586ccf717f90310b77ee76bfc.svg";
export { ForwardRef as ReactComponent };